<template>
  <div class="row d-lg-flex align-items-center mt-4">
    <div class="col-lg-12">
      <div class="intro-section__powered-by">
        <a :href="url"
           target="_blank">
          Powered by <span>getpica.com</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PoweredBy",
  props: {
    url: {
      type: String,
      required: true
    }
  }
}
</script>


<style scoped>

</style>